/* Léonie Corentin — ajoute l'icône Instagram dans l'en-tête, à GAUCHE du sélecteur de langue/région,
   même taille et même style (tracé fin) que les autres icônes du header.
   Réversible : supprimer assets/leo-header.js + la ligne script_tag dans snippets/meta-tags.liquid. */
(function () {
  var IG_URL = 'https://www.instagram.com/leoniecorentinchocolatier/';
  // Icône Instagram en CONTOUR (stroke), pour correspondre au poids visuel des autres icônes (loupe, compte, panier).
  var SVG =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
    '<rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5"></rect>' +
    '<circle cx="12" cy="12" r="4.1"></circle>' +
    '<circle cx="17.3" cy="6.7" r="1.15" fill="currentColor" stroke="none"></circle>' +
    '</svg>';

  function ensureStyle() {
    if (document.getElementById('leo-ig-style')) return;
    var st = document.createElement('style');
    st.id = 'leo-ig-style';
    // Force la même taille que les autres icônes du header (2rem dans ce thème).
    st.textContent = '.leo-ig-header .svg-wrapper svg{width:2rem;height:2rem;}';
    (document.head || document.documentElement).appendChild(st);
  }

  function build() {
    var headers = document.querySelectorAll('.header');
    if (!headers.length) return false;
    ensureStyle();
    var done = false;
    headers.forEach(function (header) {
      if (header.querySelector('.leo-ig-header')) { done = true; return; }
      var icons = header.querySelector('.header__icons');
      var wrap = header.querySelector('.desktop-localization-wrapper');
      var a = document.createElement('a');
      a.className = 'header__icon header__icon--instagram link focus-inset leo-ig-header';
      a.href = IG_URL;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', 'Instagram');
      a.innerHTML = '<span class="svg-wrapper">' + SVG + '</span>';
      // À GAUCHE du sélecteur de langue/région : juste avant le bloc de localisation.
      if (wrap && wrap.parentNode) {
        wrap.parentNode.insertBefore(a, wrap);
        done = true;
      } else if (icons) {
        icons.insertBefore(a, icons.firstChild);
        done = true;
      }
    });
    return done;
  }

  function run() { if (!build()) { setTimeout(build, 300); } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
